import { useState, useEffect } from 'react';
import { api } from '../api';

const fmt = v => '₹' + Number(v).toLocaleString('en-IN', { maximumFractionDigits: 0 });
const PM = { 'Wallet': ['var(--green-light)','var(--green-dark)'], 'Online Payment': ['var(--blue-light)','var(--blue-dark)'], 'Cash': ['var(--badge-amber-bg)','var(--badge-amber-text)'], 'Bank Deposit': ['var(--badge-tan-bg)','var(--badge-tan-text)'] };
const PT = { 'Party': ['var(--badge-purple-bg)','var(--badge-purple-text)'], 'Distributor': ['var(--badge-pink-bg)','var(--badge-pink-text)'], 'Customer': ['var(--badge-olive-bg)','var(--badge-olive-text)'] };

export default function TransactionsTable({ start, end }) {
  const [page,    setPage]    = useState(1);
  const [data,    setData]    = useState({ total: 0, data: [] });
  const [loading, setLoading] = useState(false);
  const pageSize = 50;

  useEffect(() => { setPage(1); }, [start, end]);

  useEffect(() => {
    setLoading(true);
    api.transactions(start, end, page).then(setData).finally(() => setLoading(false));
  }, [start, end, page]);

  const totalPages = Math.ceil(data.total / pageSize) || 1;

  return (
    <div className="card">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '14px', flexWrap: 'wrap', gap: '10px' }}>
        <div className="card-title" style={{ margin: 0 }}>
          Transactions
          <span style={{ marginLeft: '8px', fontSize: '12px', color: 'var(--muted)', fontWeight: 400 }}>
            ({data.total.toLocaleString('en-IN')} records)
          </span>
        </div>
        <div className="pagination">
          <button className="page-btn" onClick={() => setPage(1)}           disabled={page === 1}>«</button>
          <button className="page-btn" onClick={() => setPage(p => p - 1)} disabled={page === 1}>‹ Prev</button>
          <span style={{ fontSize: '12px', color: 'var(--muted)', padding: '0 4px' }}>Page {page} / {totalPages}</span>
          <button className="page-btn" onClick={() => setPage(p => p + 1)} disabled={page >= totalPages}>Next ›</button>
          <button className="page-btn" onClick={() => setPage(totalPages)}  disabled={page >= totalPages}>»</button>
        </div>
      </div>

      {loading ? (
        <div style={{ textAlign: 'center', padding: '40px', color: 'var(--light)' }}>
          <span className="spinner" /> Loading…
        </div>
      ) : (
        <div className="table-scroll">
          <table>
            <thead>
              <tr>
                <th>Bill No.</th>
                <th>Date</th>
                <th>Product</th>
                <th style={{ textAlign: 'center' }}>Qty</th>
                <th style={{ textAlign: 'right'  }}>Rate</th>
                <th style={{ textAlign: 'right'  }}>Total</th>
                <th>Paymode</th>
                <th>Customer</th>
                <th>City</th>
                <th>State</th>
                <th>Party</th>
              </tr>
            </thead>
            <tbody>
              {data.data.map((r, i) => {
                const [pmBg, pmTx] = PM[r.paymode]    || ['var(--badge-neutral-bg)', 'var(--badge-neutral-text)'];
                const [ptBg, ptTx] = PT[r.party_type] || ['var(--badge-neutral-bg)', 'var(--badge-neutral-text)'];
                return (
                  <tr key={`${r.bill_no}-${i}`}>
                    <td style={{ fontFamily: 'monospace', fontSize: '11px', whiteSpace: 'nowrap' }}>{r.bill_no}</td>
                    <td style={{ whiteSpace: 'nowrap', color: 'var(--muted)' }}>{r.bill_date}</td>
                    <td style={{ minWidth: '140px' }}>
                      <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: '180px' }}>{r.product_name}</div>
                    </td>
                                        <td style={{ textAlign: 'center' }}>{r.qty}</td>
                    <td style={{ textAlign: 'right', color: 'var(--muted)', whiteSpace: 'nowrap' }}>{fmt(r.rate)}</td>
                    <td style={{ textAlign: 'right', fontWeight: 600, color: 'var(--green)', whiteSpace: 'nowrap' }}>{fmt(r.total_amt)}</td>
                    <td><span className="badge" style={{ background: pmBg, color: pmTx }}>{r.paymode}</span></td>

                    <td style={{ minWidth: '120px' }}>
                      <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: '160px', fontWeight: 500 }}>{r.customer_name}</div>
                      <div style={{ fontSize: '11px', color: 'var(--light)' }}>{r.customer_id}</div>
                    </td>
                    
                    <td style={{ color: 'var(--muted)', whiteSpace: 'nowrap' }}>{r.city}</td>
                    <td style={{ color: 'var(--muted)', whiteSpace: 'nowrap' }}>{r.state}</td>
                    

                    <td><span className="badge" style={{ background: ptBg, color: ptTx }}>{r.party_type}</span></td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
